import React from "react";
import { Alert } from "antd";

export default function DefaultFilterAlert({ style }) {
	return <Alert message="Analytics below only cover utility applications filed after 2000-01-01." type="info" style={style} />;
}